import { useEffect, useState, useMemo } from 'react'
import Modal from '../../../components/utils/Model';
import Button from '../../../components/utils/Button';
import { useDispatch, useSelector } from 'react-redux';
import dailyPlanRequestActions from '../../../redux/dailyPlanRequest/actions'
import { useForm } from "react-hook-form";
import Alert from '../../../components/utils/Alert';
import authActions from '../../../redux/auth/actions';
import moment from 'moment';
import { twoDigitDecimal } from '../../../helpers/commonFunction';

const { refundDailyPlanRequest, resetDailyPlan } = dailyPlanRequestActions;

const DailyPlanRefund = ({ row, modal, close, search }) => {
    const dispatch = useDispatch();
    const { getUserDataByToken } = authActions;
    const {
        refundDailyPlanRequestLoading,
        refundDailyPlanRequestError,
        refundDailyPlanRequestMessage
    } = useSelector((state) => state.dailyPlanRequest);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');


    const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: {} });

    useEffect(() => {
        dispatch(resetDailyPlan());
    }, []);

    useEffect(() => {
        if (refundDailyPlanRequestError !== null && refundDailyPlanRequestError !== undefined) {
            displayAlert(refundDailyPlanRequestError, 'alert-danger');
        }
        if (refundDailyPlanRequestMessage !== null && refundDailyPlanRequestMessage !== undefined) {
            close();
        }
    }, [refundDailyPlanRequestError, refundDailyPlanRequestMessage]);

    useEffect(() => {
        dispatch(getUserDataByToken());
    }, [])

    const onSubmit = (data) => {
        data.RefundedDays = refundedDays;
        data.DailyPlanRequestID = row.ID;
        // console.log('data ', data);
        dispatch(refundDailyPlanRequest(data, search));
    }

    const displayAlert = (text, type) => {
        setShowAlert(true);
        setAlertText(text);
        setAlertType(type);
        dispatch(resetDailyPlan());
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetDailyPlan());
    }

    const refundedDays = useMemo(() => {
        if (row) {
            let RequestedToDate = moment(moment(row.RequestedToDate).format('YYYY-MM-DD'));
            let currentDate = moment(moment().format('YYYY-MM-DD'));
            const diffInDays = RequestedToDate.diff(currentDate, 'days');
            return diffInDays;
        } else {
            return 0
        }
    }, [row]);

    return (
        <Modal
            showModal={modal}
            title={`REFUND DAILY PLAN REQUEST: ${row.TransactionID}`}
            onHide={() => close()}
            width={700}
            showFooter={false}
        >
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-row">
                    <div className="col-lg-3 mb-3 d-flex flex-column">
                        <label>SIM Type</label>
                        <p>{row.SimTypeValue}</p>
                    </div>

                    <div className="col-lg-3 mb-3 d-flex flex-column">
                        <label>IMEI</label>
                        <p>{row.IMEI}</p>
                    </div>

                    <div className="col-lg-3 mb-3 d-flex flex-column">
                        <label>From Date</label>
                        <p>{moment(new Date(row.RequestedDtTm)).format('YYYY-MM-DD')}</p>
                    </div>

                    <div className="col-lg-3 mb-3 d-flex flex-column">
                        <label>To Date</label>
                        <p>{moment(new Date(row.RequestedToDate)).format('YYYY-MM-DD')}</p>
                    </div>

                    <div className="col-lg-3 mb-3 d-flex flex-column">
                        <label>Zip Code</label>
                        <p>{row.AreaCode}</p>
                    </div>

                    <div className="col-lg-3 mb-3 d-flex flex-column">
                        <label>Total Days</label>
                        <p>{row.RequestedDays} Days</p>
                    </div>
                    <div className="col-lg-6 mb-3">
                        <label>SIM Number</label>
                        <p>{row.SerialNumber}</p>
                    </div>

                    <div className="col-lg-12 mb-3 d-flex flex-column">
                        <label>Customer Email</label>
                        <p>{row.CustomerEmailID}</p>
                    </div>

                    <div className="col-md-12 mb-3">
                        <label>Remark</label>
                        <textarea className="form-control" placeholder="Enter Remark" id="remark" name="remark" rows="3" cols="30" {...register("remark", {
                            required: 'Remark is required!'
                        })}>
                        </textarea>
                        {errors.remark && (<div className="invalid-feedback">{errors.remark.message}</div>)}
                    </div>
                </div>

                <div className='d-flex justify-content-around bg-success ' style={{ padding: "8px", borderRadius: "4px" }}>
                    <h5 className='font-weight-bold text-white px-lg-3 px-1'> Daily Rate : ${twoDigitDecimal(row.DailyPlanRequestChargedAmount)} </h5>
                    <h5 className='font-weight-bold text-white px-lg-3 px-1'>Refund For : {refundedDays > 1 ? `${refundedDays} Days` : `${refundedDays} Day`}</h5>
                    <h5 className='font-weight-bold text-white px-lg-3 px-1'> Refunded Amount : ${twoDigitDecimal(row.DailyPlanRequestChargedAmount * refundedDays)} </h5>
                </div>

                <hr />
                <div className='text-right row'>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-secondary mr-2" onClick={() => close()}>Close</button>
                        <Button title="Submit" loading={refundDailyPlanRequestLoading} buttonClass="btn btn-primary" buttonType='submit' />
                    </div>
                </div>
            </form>
        </Modal>
    )
}

export default DailyPlanRefund;